import React, {useState} from 'react';
import './style.css';
import pdfMake from 'pdfmake/build/pdfmake';
import pdfFonts from 'pdfmake/build/vfs_fonts';
import logo from '../../../Resource/Images/Logos/PBSS-logo.png';
import useLocalization from '../../../Localization';
import {
  formatCurrency,
  formatDate,
  formatUtcToLocalDateTime,
} from '../../../Util/commonUtility';
import {ensureInterPdfFont} from './ensureInterPdfFont';

const {buildAdJobReceiptDocDefinition} = require('./buildAdJobReceiptDoc');

pdfMake.addVirtualFileSystem(
  (pdfFonts && pdfFonts['Roboto-Regular.ttf'] && pdfFonts) ||
    pdfFonts?.default ||
    pdfFonts?.pdfMake?.vfs ||
    pdfFonts?.vfs ||
    {},
);

const fetchImageAsDataUrl = async (imageUrl) => {
  const response = await fetch(imageUrl);
  const blob = await response.blob();
  return new Promise((resolve, reject) => {
    const reader = new FileReader();
    reader.onloadend = () => resolve(reader.result);
    reader.onerror = reject;
    reader.readAsDataURL(blob);
  });
};

/**
 * @param {'ad'|'job'} type
 * @param {object} item listing fields + payment
 */
const AdJobReceipt = ({type, item}) => {
  const {ApplicationString} = useLocalization();
  const [isDownloading, setIsDownloading] = useState(false);

  const handleDownloadPDF = async () => {
    if (!item) return;
    setIsDownloading(true);
    try {
      const [logoDataUrl] = await Promise.all([
        fetchImageAsDataUrl(logo),
        ensureInterPdfFont(),
      ]);
      const strings = {
        adReceipt: ApplicationString['receiptComponent.adReceipt'],
        jobReceipt: ApplicationString['receiptComponent.jobReceipt'],
        logoText: ApplicationString['receiptComponent.logoText'],
        vendor: ApplicationString['receiptComponent.vendor'],
        employer: ApplicationString['receiptComponent.employer'],
        position: ApplicationString['receiptComponent.position'],
        positionDesignation:
          ApplicationString['receiptComponent.positionDesignation'],
        location: ApplicationString['receiptComponent.location'],
        contactInfo: ApplicationString['receiptComponent.contactInfo'],
        attachmentUrl: ApplicationString['receiptComponent.attachmentUrl'],
        email: ApplicationString['receiptComponent.email'],
        adType: ApplicationString['receiptComponent.adType'],
        jobType: ApplicationString['receiptComponent.jobType'],
        months: ApplicationString['receiptComponent.months'],
        listingPeriod: ApplicationString['receiptComponent.listingPeriod'],
        jobNotApprovedYet:
          ApplicationString['receiptComponent.jobNotApprovedYet'],
        adNotApprovedYet:
          ApplicationString['receiptComponent.adNotApprovedYet'],
        description: ApplicationString['receiptComponent.description'],
        requirement: ApplicationString['receiptComponent.requirement'],
        advertiserName: ApplicationString['receiptComponent.advertiserName'],
        paymentDetails: ApplicationString['receiptComponent.paymentDetails'],
        paymentDate: ApplicationString['receiptComponent.paymentDate'],
        cardLast4: ApplicationString['receiptComponent.cardLast4'],
        price: ApplicationString['receiptComponent.price'],
        total: ApplicationString['receiptComponent.total'],
        totalPrice: ApplicationString['receiptComponent.totalPrice'],
      };
      const docDefinition = buildAdJobReceiptDocDefinition({
        type,
        item,
        strings,
        logoDataUrl,
        formatCurrency: (value, currencyCode) =>
          formatCurrency(value, currencyCode || 'USD', 2, 2),
        formatDate: (value) => (value ? formatDate(value) : 'N/A'),
        formatPaymentDate: (value) =>
          value ? formatUtcToLocalDateTime(value) : 'N/A',
        formatListingDate: (value) =>
          value ? formatUtcToLocalDateTime(value) : 'N/A',
      });
      const {meta, ...pdfDoc} = docDefinition;
      const pdfBlob = await new Promise((resolve) => {
        pdfMake.createPdf(pdfDoc).getBlob(resolve);
      });
      const pdfUrl = URL.createObjectURL(pdfBlob);
      const downloadLink = document.createElement('a');
      downloadLink.href = pdfUrl;
      downloadLink.download = meta.filename;
      document.body.appendChild(downloadLink);
      downloadLink.click();
      document.body.removeChild(downloadLink);
      const newWindow = window.open('', '_blank');
      if (newWindow) {
        newWindow.document.write(`
          <html>
            <head><title>${meta.filename}</title></head>
            <body style="margin:0;padding:0;">
              <embed width="100%" height="100%" src="${pdfUrl}" type="application/pdf">
            </body>
          </html>
        `);
        newWindow.document.close();
      }
    } catch (err) {
      console.error('Error generating PDF:', err);
      alert('Error generating PDF. Please try again.');
    } finally {
      setIsDownloading(false);
    }
  };

  return (
    <button
      type='button'
      className='download-button ad-job-receipt-download-button'
      id={`adJobReceipt-download-${type}-${item?.id || item?.jobId}`}
      onClick={handleDownloadPDF}
      disabled={isDownloading}>
      <div className='docs'>
        {isDownloading
          ? ApplicationString['receiptComponent.downloading']
          : ApplicationString['receiptComponent.downloadReceipt']}
      </div>
      <div className='download'>
        <svg
          className='css-i6dzq1'
          strokeLinejoin='round'
          strokeLinecap='round'
          fill='none'
          strokeWidth='2'
          stroke='currentColor'
          height='20'
          width='20'
          viewBox='0 0 24 24'>
          <path d='M21 15v4a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2v-4'></path>
          <polyline points='7 10 12 15 17 10'></polyline>
          <line x1='12' y1='15' x2='12' y2='3'></line>
        </svg>
      </div>
    </button>
  );
};

export default AdJobReceipt;
